<div class="animated fadeIn fast">
  <h1 class="font-text" style="margin: 0px; padding: 0px; padding-bottom: 10px">{{ viewTitle }}</h1>
  <mat-divider></mat-divider>
  <br />

  <div class="details" *ngIf="showForm">
    <div class="row">
      <h1>Complete la información</h1>
      <div class="col-5 content-left">
        <h2 class="font-text" style="margin: 0px">Información general</h2>
        <p style="color: var(--primary-m-gray)">Introduzca los campos requeridos (*) a agregar.</p>
      </div>

      <div class="col-6 content-right">
        <form autocomplete="off" [formGroup]="createCategoryForm">
          <div class="row" *ngIf="isParentCategory">
            <mat-form-field class="col-xs-12 col-md-5 font-text" appearance="fill">
              <mat-label>{{ loadCsv ? 'Parent ID' : 'ID' }}</mat-label>
              <input matInput required formControlName="parentId" />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field class="col-xs-12 col-md-12 font-text" appearance="fill">
              <mat-label>Nombre de Categoría</mat-label>
              <input matInput required formControlName="nombre" />
            </mat-form-field>
          </div>

          <mat-form-field class="col-sm-12 font-text" appearance="fill">
            <mat-label>Fuente</mat-label>
            <input matInput required formControlName="fuente" />
          </mat-form-field>

          <div style="display: flex">
            <mat-checkbox
              class="example-margin"
              (change)="setRed($event)"
              [checked]="createCategoryForm.value?.red"
              formControlName="red"
              value="true"
            >
            </mat-checkbox>
            <h4 class="font-text" style="margin-left: 5px">Red</h4>
          </div>

          <mat-form-field class="full-width" appearance="fill" class="font-text">
            <mat-label>Descripción</mat-label>
            <textarea matInput required style="min-height: 100px" formControlName="description">
            </textarea>
          </mat-form-field>

          <div class="row">
            <div class="col-sm-6">
              <input
                #iconInput
                type="file"
                hidden="true"
                accept=".png, .jpg, .gif"
                (change)="onChangeIcon($event)"
              />
              <button
                mat-stroked-button
                color="accent"
                class="button-send font-text"
                style="margin-bottom: 15px"
                (click)="iconInput.click()"
              >
                Seleccionar icono <mat-icon>file_upload</mat-icon>
              </button>
            </div>
            <div class="col-sm-6">
              <input
                #markerInput
                type="file"
                hidden="true"
                accept=".png, .jpg, .gif"
                (change)="onChangeMarker($event)"
              />
              <button
                mat-stroked-button
                color="accent"
                class="button-send"
                style="margin-bottom: 15px"
                (click)="markerInput.click()"
              >
                Seleccionar marcador <mat-icon>file_upload</mat-icon>
              </button>
            </div>
          </div>

          <button
            mat-stroked-button
            color="accent"
            class="button-upload float-end font-text"
            [disabled]="!createCategoryForm.valid"
            (click)="save()"
          >
            Guardar <mat-icon>save</mat-icon>
          </button>

          <button
            mat-stroked-button
            class="button-upload"
            color="accent"
            aria-label="View"
            matTooltip="Volver al inicio"
            [routerLink]="['/', 'categories']"
          >
            <mat-icon>arrow_circle_left</mat-icon>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
